import { isFieldGroup } from '@modusign/react-signing';
import { FieldNode } from '@modusign/react-signing/types';
import { DeepReadonly } from 'ts-essentials';

// React-signing 에서 노출하는거 고려하기
export function filterFieldNodes<T extends FieldNode | DeepReadonly<FieldNode>>(
  children: T[] | DeepReadonly<T[]>,
  predicate: (node: FieldNode) => boolean
): FieldNode[] {
  const nodes = [];
  for (let i = 0; i < children.length; i += 1) {
    const child = children[i];

    if (predicate(child as FieldNode)) {
      nodes.push(child);
    }

    if (isFieldGroup(child) && child.children.length > 0) {
      filterFieldNodes(child.children, predicate).forEach((filtered) => nodes.push(filtered));
    }
  }
  return nodes as FieldNode[];
}
